import React from 'react';
import '../stili/ConfirmModal.css';

export default function ConfirmModal({
  open,
  isOpen,
  title = 'Conferma operazione',
  message = 'Sei sicuro di voler continuare?',
  confirmText = 'Conferma',
  cancelText = 'Annulla',
  onConfirm,
  onCancel,
  onClose,
  danger = false,
}) {
  const visible = typeof isOpen === 'boolean' ? isOpen : open;
  const handleClose = onCancel || onClose;

  if (!visible) return null;

  return (
    <div className="confirmmodal-overlay" onClick={handleClose}>
      <div
        className="confirmmodal-card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirmmodal-title"
      >
        <h3 id="confirmmodal-title" className="confirmmodal-title">
          {title}
        </h3>

        <div className="confirmmodal-message">
          {typeof message === 'string' ? <p>{message}</p> : message}
        </div>

        <div className="confirmmodal-actions">
          <button
            type="button"
            className="confirmmodal-btn-secondary"
            onClick={handleClose}
          >
            {cancelText}
          </button>

          <button
            type="button"
            className={danger ? 'confirmmodal-btn-danger' : 'confirmmodal-btn-primary'}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}